/**
 * Suppress the global PhoneGate sheet while a surface handles the phone gate
 * itself.
 *
 * PhoneGate opens on the apiClient's `cluck:phone-required` event, from
 * anywhere. When that fires while a Radix Dialog is open, the sheet paints on
 * top (z-[10001]) but cannot be clicked: Radix traps pointer events inside the
 * Dialog's own subtree, so the player has to dismiss the dialog to reach a
 * button that is already covering it. Two verify prompts stacked, and the
 * visible one inert.
 *
 * A surface that shows its own verify CTA (the wheel modal does) calls
 * suppress() while it is open and release() when it closes.
 *
 * A counter rather than a boolean so overlapping surfaces cannot release each
 * other's suppression.
 */

let depth = 0;

export const suppressPhoneGate = () => {
  depth += 1;
};

export const releasePhoneGate = () => {
  depth = Math.max(0, depth - 1);
};

export const isPhoneGateSuppressed = () => depth > 0;
